
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import Select from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';

const WorkDetailsEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId]);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // UOM 
    const [UomOptions, setUomOptions] = useState([]);
    const [selecteduom, setSelectedUom] = useState("");

    const fetchUOM = async () => {
        try {
            const response = await fetchData('UOMApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(WrokData => ({
                    value: WrokData.Id,
                    label: WrokData.Name
                }));
                setUomOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleUOMChange = (selectedOption) => {
        setSelectedUom(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            CompanyId: companyId,
            UnitofMeasuresId: selectedOption.value,
        }));
    };

    const handleWorkChange = (selectedOption) => {
        setSelectedWork(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            CompanyId: companyId,
            WorkId: selectedOption.value,
        }));
    };

    useEffect(() => {
        // fetchWork();
        fetchUOM();
    }, []);

    const [formData, setFormData] = useState({});
    const [workId, setWorkId] = useState("");
    const [CustomerRateRelation, setCustomerRateRelation] = useState([]);

    useEffect(() => {
        fetchData('WorkDetailsApi', `/SubWorkDetails/${id}`, token)
            .then((response) => {
                console.log('API response:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                    setWorkId(response.response_data.WorkId);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, userId, token]);

    // WorkItem
    const [WorkOptions, setWorkOptions] = useState([]);
    const [selectedWork, setSelectedWork] = useState("");

    useEffect(() => {
        const fetchWork = async () => {
            if (!workId) return; // only fetch if workId is available
            try {
                const response = await fetchData('WorkItemApi', `/CreatedSubWorkItemList/${workId}`, token);
                if (response.responseCode === '1111') {
                    const options = response.response_data.map(WorkData => ({
                        value: WorkData.Id,
                        label: WorkData.Description
                    }));
                    setWorkOptions(options);
                }
            } catch (error) {
                console.error('Error fetching work items:', error);
            }
        };

        fetchWork();
    }, [workId, token]);


    const submitData = async () => {
        // Update CreatedBy field
        setFormData((prevData) => ({
            ...prevData,
            CreatedBy: userId,
        }));

        // Fetch existing items for validation
        const existingItems = await fetchData('WorkDetailsApi', `/${companyId}`, token);
        console.log('Existing Items:', existingItems);

        const existingItem = existingItems.response_data?.find(
            (item) => item.Description === formData.Description
        );

        // Validate mandatory fields
        if (!formData.Description) {
            alert('Description is required.');
            return;
        }

        if (!formData.HSNCode) {
            alert('HSN Code is required.');
            return;
        }

        // Update data
        try {
            const response = await updateData('WorkDetailsApi', id, formData, token); //, token
            console.log('Record updated successfully:', response);
            setSuccessMessage('Record updated successfully.');
            setTimeout(() => setSuccessMessage(''), 3000);
            history.push('/WorkDetailsIndex');
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const [editIndex, setEditIndex] = useState(null);
    const [editedData, setEditedData] = useState({});

    const handleEditClick = (index) => {
        setEditIndex(index);
        setEditedData(CustomerRateRelation[index]);
    };

    const handleInputChange = (field, value) => {
        setEditedData({
            ...editedData,
            [field]: value,
        });
    };

    const handleSaveClick = (index) => {
        handleEditChange(index, editedData);
        setEditIndex(null);
    };

    const handleEditChange = (index, updatedData) => {

        const updatedSlabs = CustomerRateRelation.map((slab, idx) =>
            idx === index ? updatedData : slab
        );
        setCustomerRateRelation(updatedSlabs);
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '-25px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item Details Edit</h6>

                    <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0, marginTop: '-10px' }}>
                        {/* Save Button */}
                        <Button
                            variant="contained"
                            onClick={submitData}
                            disabled={isLoading}
                            style={{
                                height: "25px",
                                minWidth: "80px",
                                borderRadius: "6px",
                                backgroundColor: "#1E3A8A",
                                color: "#FFFFFF",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                        >
                            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Update"}
                        </Button>

                        {/* Back To List Button */}
                        <Button
                            variant="contained"
                            component={Link}
                            to="/WorkDetailsIndex"
                            className="linkcolor"
                            onClick={() => localStorage.setItem("shouldReload", "true")}
                            style={{
                                height: "25px",
                                minWidth: "90px",
                                borderRadius: "6px",
                                backgroundColor: "#F3F4F6",
                                color: "#1E3A8A",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                        >
                            Back To List
                        </Button>
                    </div>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div className="w-full flex flex-wrap">
                    <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                        <div className="w-full mb-3 flex" >
                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Work<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.WorkName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="WorkName"
                                    name='WorkName'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Item<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    //value={selectedCustomerType}
                                    value={selectedWork || (formData.WorkItemName ? { value: formData.WorkItemId, label: formData.WorkItemName } : '')}
                                    onChange={handleWorkChange}
                                    options={WorkOptions}
                                    placeholder="Select Item"
                                    isSearchable
                                />
                            </div>
                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Name"
                                    name='Name'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    UOM<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    value={selecteduom || (formData.UOM ? { value: formData.UnitofMeasuresId, label: formData.UOM } : '')}
                                    onChange={handleUOMChange}
                                    options={UomOptions}
                                    placeholder="UOM"
                                    isSearchable
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    HSN Code<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.HSNCode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="HSN Code"
                                    name='HSNCode'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    GST Rate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GSTRate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="GST Rate"
                                    name='GSTRate'
                                    onClick={(e) => e.target.select()}
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Rate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Rate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Rate"
                                    name='Rate'
                                    onClick={(e) => e.target.select()}
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-3 flex" >
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Description<span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Description}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Description"
                                    name='Description'
                                    rows={3}
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    );
};

export default WorkDetailsEdit;